import React from "react";


import GOQiiHomeScreen from "./GOQiiHomeScreen";
import HomeHudHeader from "./HomeHudHeader";

const Dashboard = () => {
  return (
    <div>
      <HomeHudHeader />
      <GOQiiHomeScreen/>
    </div>
  );
};

export default Dashboard;